import React from 'react';
import { useTranslation } from "react-i18next";

function SectionHeader({title,path}) {
  // const { t } = useTranslation();
  const { t } = useTranslation("home");
  return (
    <div className='d-flex justify-content-between align-items-center'>
    <div className="section_title">{t(title)}</div>    
    <div className="section_all">
        <a href={`${path}`}>View All</a>
    </div>    

    </div>
  )
}

export default SectionHeader